module.exports = __webpack_public_path__ + "static/4-Tips-To-Improve-Your-Email-Campaign-64c0f14b31fd8ac4c12a3fa6c57aa144.jpg";